<template>
  <RouterView></RouterView>
  <div class="modal-target" />
</template>

<script lang="ts" setup>
  import '@/app/styles/main.scss';
  import '@experience/design-tokens/color.css';
  import '@experience/design-tokens/dimension.css';

  import { reportMFRendered, captureException } from '@experience/core-hostapp-share-lib';
  import { initHotReloader } from '@experience/vite-plugin-wc-extract-styles';
  import { onErrorCaptured, onMounted, nextTick, provide, useShadowRoot } from 'vue';
  import { useRouter } from 'vue-router';

  import { useExperienceClient } from '@/shared/api/useExperienceApiClient';
  import { MF_NAME, SENTRY_DSN } from '@/shared/consts';

  onErrorCaptured((err) => captureException(err, { mf: MF_NAME, dsn: SENTRY_DSN, mfRelease: __APP_VERSION__ }));

  const router = useRouter();
  const shadowRoot = useShadowRoot();

  provide('shadowRoot', shadowRoot);
  initHotReloader(import.meta.hot, shadowRoot);

  onMounted(async () => {
    // Убеждаемся, что маршрутизатор полностью инициализирован
    await router.isReady();
    // Ждём окончания текущего рендера
    await nextTick();
    // Откладываем вызов на следующий цикл, чтобы DOM гарантированно обновился
    setTimeout(() => {
      reportMFRendered(MF_NAME);
    }, 0);
  });

  useExperienceClient();
</script>
